import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRegSadTear } from "react-icons/fa";

export default function ErrorPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/"); // Redirect to homepage
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 py-12">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md text-center">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <FaRegSadTear className="text-indigo-600 text-6xl" />
        </div>

        {/* Heading */}
        <h1 className="text-4xl font-bold text-indigo-700 mb-2">Oops!</h1>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          Something went wrong. We couldn’t find the page you're looking for.
        </p>

        {/* Button */}
        <button
          onClick={handleGoHome}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition focus:outline-none focus:ring-2 focus:ring-indigo-400"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}
